import { Injectable } from "@angular/core";
import { MatIconRegistry } from "@angular/material/icon";
import { DomSanitizer } from "@angular/platform-browser";

@Injectable({
  providedIn: "root",
})
export class IconService {
  private icons: { name: string; path: string }[] = [
    { name: "icon_adm", path: "assets/svg/icon-adm.svg" },
    { name: "icon_monitoramento", path: "assets/svg/icon-monitoramento.svg" },
    { name: "icon_padrao", path: "assets/svg/icon-padrao.svg" },
    { name: "icon_cadastro", path: "assets/svg/icon-cadastro.svg" },
    { name: "icon_senha", path: "assets/svg/icon-senha.svg" },
    { name: "icon_sair", path: "assets/svg/icon-sair.svg" },
  ];

  constructor(
    private iconRegistry: MatIconRegistry,
    private sanitizer: DomSanitizer
  ) {
    this.registerIcons();
  }
  private registerIcons() {
    this.icons.forEach((icon) => {
      this.iconRegistry.addSvgIcon(
        icon.name,
        this.sanitizer.bypassSecurityTrustResourceUrl(icon.path)
      );
    });
  }
}
